export const formatPhoneNumber = (phoneNumber: string): string => {
  if (typeof phoneNumber !== 'string') return phoneNumber;

  // Filter only numbers from the input and then remove area country code
  const cleaned = phoneNumber.replace(/\D/g, '');
  const cleanedWithoutCountryCode =
    cleaned.charAt(0) === '1' ? cleaned.slice(1) : cleaned;

  // Check if the input is of correct length
  const match = cleanedWithoutCountryCode.match(/^(\d{3})(\d{3})(\d{4})$/);

  // if there is a correct match, then format and return
  if (match) {
    return `(${match[1]}) ${match[2]}-${match[3]}`;
  }

  // otherwise return original input
  return phoneNumber;
};
